// extracted by mini-css-extract-plugin
export var button = "ButtonControl-module--button--pliEn";
export var text = "ButtonControl-module--text--yKohh";